import './App.css';
import Todo from './components/Todo'
import React from 'react'

function App() {
  return (
    <div className="container">
      <Todo />
    </div>
  );
}

export default App;
